import { Button, Card, CardContent, Typography } from '@mui/material';
import { FallbackProps } from 'components/core/AlluraErrorBoundary/AlluraErrorBoundary';
import styled from 'styled-components';

const StyledContainer = styled.div`
  margin-top: ${props => props.theme.layout.toolBarHeight.sm}px;
  height: calc(100vh - ${props => props.theme.layout.toolBarHeight.sm}px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledErrorMessage = styled.pre`
  color: ${props => props.theme.palette.error.main};
`;

const isDevelopment = process.env.NODE_ENV === 'development';

export const FullScreenErrorFallback = ({ error }: FallbackProps) => {
  return (
    <StyledContainer role="alert">
      <Card>
        <CardContent>
          <Typography variant="body2">
            Sorry, something went wrong and we couldn&apos;t complete the action. Our developers have been alerted and
            will track down the issue!
          </Typography>
          {isDevelopment ? <StyledErrorMessage>{error.message}</StyledErrorMessage> : null}
          <Button variant="outlined" color="secondary" onClick={() => window?.location.reload()}>
            Try again
          </Button>
        </CardContent>
      </Card>
    </StyledContainer>
  );
};
